module.exports = __webpack_public_path__ + "img/4.6d4db71e.jpg";